import { render, staticRenderFns } from "./IntegracionExpedienteExtranjero.vue?vue&type=template&id=51c55530&scoped=true&"
import script from "./IntegracionExpedienteExtranjero.vue?vue&type=script&lang=js&"
export * from "./IntegracionExpedienteExtranjero.vue?vue&type=script&lang=js&"
import style0 from "./IntegracionExpedienteExtranjero.vue?vue&type=style&index=0&id=51c55530&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c55530",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
